import { render } from "./MainLogo.vue?vue&type=template&id=7959c7c9&scoped=true&ts=true"
import script from "./MainLogo.vue?vue&type=script&lang=ts"
export * from "./MainLogo.vue?vue&type=script&lang=ts"

import "./MainLogo.vue?vue&type=style&index=0&id=7959c7c9&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7959c7c9"]])

export default __exports__